import React from "react";
import propTypes from "prop-types";
import { Col } from "reactstrap";
import { Autocomplete, TextField } from "@mui/material";

import "./styles.scss";

function FormCreator({ form_component, model, translate, catalogs, onchange }) {
  const FORM_ITEMS = form_component
    ? form_component.map((item, key) => {
        if (item.type === "select") {
          return (
            <Col
              key={key}
              md={item.colm}
              xl={item.colm}
              className={item.class}
              hidden={model && model[item.id].hidden === true ? true : false}
            >
              <label className="title-custom-value">
                {translate(item.label)}
                {item.required ? <em style={{ color: "#E74C3C" }}>*</em> : ""}
              </label>
              <Autocomplete
                options={catalogs && catalogs[item.id] ? catalogs[item.id] : []}
                onChange={(evt, data) => {
                  onchange(data, item);
                }}
                ListboxProps={{
                  sx: {
                    fontSize: 12,
                    color: "#000",
                  },
                }}
                sx={{
                  "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                    fontSize: 12,
                    color: "#000",
                  },
                }}
                clearOnEscape
                renderInput={(params) => (
                  <TextField {...params} variant="standard" />
                )}
              />
            </Col>
          );
        } else if (item.type === "input") {
          return (
            <Col
              key={key}
              md={item.colm}
              xl={item.colm}
              className={item.class}
              hidden={model && model[item.id].hidden === true ? true : false}
            >
              <label className="title-custom-value">
                {translate(item.label)}
                {item.required ? <em style={{ color: "#E74C3C" }}>*</em> : ""}
              </label>
              <TextField
                variant="standard"
                onChange={(evt, data) => {
                  onchange(evt.target.value, item);
                }}
                InputProps={{
                  classes: {
                    input: "input-basic",
                  },
                }}
              />
            </Col>
          );
        } else if (item.type === "info") {
          return (
            <Col
              key={key}
              md={item.md ? item.md : item.colm}
              xl={item.colm}
              className={item.class}
              hidden={model && model[item.id].hidden === true ? true : false}
            >
              <label className="label-forms table-td">
                {translate(item.label)}
              </label>
              <p className="tag-custom-value table-td">
                {model && model[item.id].label
                  ? model[item.id].label
                  : model && model[item.id].value
                  ? model[item.id].value
                  : ""}
              </p>
            </Col>
          );
        } else return "";
      })
    : [];
  return <React.Fragment>{FORM_ITEMS}</React.Fragment>;
}

FormCreator.propTypes = {
  dataForm: propTypes.array,
  Catalog: propTypes.object,
  config: propTypes.object,
  inptIconHandler: propTypes.func,
  model: propTypes.object,
  onChange: propTypes.func,
  placeholders: propTypes.object,
  type: propTypes.string,
};

FormCreator.defaultProps = {
  dataForm: [],
  Catalog: {},
  config: undefined,
  inptIconHandler: () => {},
  model: {},
  onChange: () => {},
  placeholder: undefined,
  // type: '---'
};

export default FormCreator;
